import { useTranslation } from '@sib/i18n';
import { Button } from '@sib/ui';
import { Edit, Add } from '@sib/ui/icons';

interface TaskTagFieldFooterProps {
  onTagAdd: () => void;
  onTagEdit: () => void;
}

export const TaskTagFieldFooter = ({
  onTagAdd,
  onTagEdit,
}: TaskTagFieldFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-stretch gap-1 pb-1">
      <div className="hover:bg-surface-soft rounded-sm">
        <Button
          variant="ghost"
          onClick={onTagAdd}
          className="w-full justify-start"
        >
          <Add className="mr-2" />
          {t('components.taskForm.fields.tag.addTag')}
        </Button>
      </div>
      <div className="hover:bg-surface-soft rounded-sm">
        <Button
          variant="ghost"
          onClick={onTagEdit}
          className="w-full justify-start"
        >
          <Edit className="mr-2 size-4" />
          {t('components.taskForm.fields.tag.editTags')}
        </Button>
      </div>
    </div>
  );
};
